import ContentBlock from "@/components/content-block/index";
import dynamicLocalization from "@/mixins/dynamic-localization";

export default {
  props: {
    title: {
      type: Object,
      required: true,
    },
    description: {
      type: Array,
      required: false,
    },
    priceMatrix: {
      type: Object,
      required: true,
    },
    priceCategories: {
      type: Object,
      required: true,
    },
    ticketShop: {
      type: String,
      required: false,
    },
    buttonText: {
      type: Object, // translated
      required: false,
      default: {
        en: "Get Ticket",
        de: "Ticket kaufen",
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [dynamicLocalization],
  components: { ContentBlock },
  computed: {
    priceCategoryNames() {
      return Object.keys(this.priceMatrix);
    },
  },
};
